import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 5px;
  text-align: center;
`;

const EmptyPage = () => {
  return (
    <Wrapper>
      <p>This page doesn't exist.</p>
    </Wrapper>
  );
};

export default EmptyPage;
